<template>
    <div data-test-id="l-reviews-cycles-edit-participant-form">
        <div id="modal-body">
            <h4>
                <l-text :text="$t(`reviews.updateParticipant.labelParticipant`)" />
            </h4>

            <l-space :size="1" />

            <l-input-text
                :label="$t(`reviews.updateParticipant.labelName`)"
                :value="participant.reviewee.fullname"
                disabled
            >
                <template v-slot:addon>
                    <span class="color-primary">
                        <span
                            v-show="participant.reviewee.status == 'complete'"
                            v-b-popover.hover.bottom="
                                $t(`reviews.updateParticipant.unlockRevieweeAssessment`)
                            "
                            class="clickable"
                            tabindex="0"
                            @click="
                                unlockRevieweeAsOwner(participant.reviewee.unlocked ? false : true)
                            "
                            @keyup.enter="
                                unlockRevieweeAsOwner(participant.reviewee.unlocked ? false : true)
                            "
                        >
                            <i
                                :class="[
                                    'fal',
                                    participant.reviewee.unlocked ? 'fa-unlock' : 'fa-lock',
                                ]"
                            ></i>
                        </span>
                    </span>
                </template>
            </l-input-text>

            <div v-if="reviewCycle.managerReviewsEnabled">
                <h4>
                    <l-text
                        :text="
                            $t(`reviews.updateParticipant.labelManagerOf`, {
                                name: participant.reviewee.fullname,
                            })
                        "
                    />
                </h4>

                <l-space :size="1" />

                <div v-for="(manager, index) in participant.managers" :key="manager._id">
                    <template v-if="manager.editInput">
                        <div style="display: flex; align-content: center;">
                            <l-input-typeahead
                                style="flex-grow: 1;"
                                :label="$t(`reviews.updateParticipant.labelName`)"
                                :placeholder="``"
                                :data="users"
                                :on-select="updateManagerAsOwner"
                                :on-input-change="typeaheadUsersOnInput"
                            >
                            </l-input-typeahead>
                            <span
                                class="color-primary"
                                style="padding: 0px 12px;padding-top: 18px;font-size: 1.8rem;"
                            >
                                <span
                                    v-show="manager.status == 'pending'"
                                    class="clickable"
                                    tabindex="0"
                                    @click="removeManagerAsOwner()"
                                    @keyup.enter="removeManagerAsOwner()"
                                >
                                    <i class="fal fa-trash"></i>
                                </span>
                                <span
                                    v-show="manager.status == 'complete'"
                                    v-b-popover.hover.bottom="
                                        $t(`reviews.updateParticipant.unlockManagerAssessment`)
                                    "
                                    class="l-default-margin-s clickable"
                                    tabindex="0"
                                    @click="unlockManagerAsOwner()"
                                    @keyup.enter="unlockManagerAsOwner()"
                                >
                                    <i v-show="manager.unlocked" class="fal fa-unlock"></i>
                                    <i v-show="!manager.unlocked" class="fal fa-lock"></i>
                                </span>
                                <span
                                    v-show="
                                        manager.status == 'complete' &&
                                            manager.visibility == 'private'
                                    "
                                    v-b-popover.hover.bottom="
                                        $t(`reviews.updateParticipant.shareManagerAssessment`)
                                    "
                                    class="l-default-margin-s clickable"
                                    tabindex="0"
                                    @click="$set(manager, 'shared', !manager.shared)"
                                    @keyup.enter="$set(manager, 'shared', !manager.shared)"
                                >
                                    <i v-show="manager.shared" class="fal fa-share-all"></i>
                                    <i v-show="!manager.shared" class="fal fa-share"></i>
                                </span>
                            </span>
                        </div>
                    </template>
                    <template v-else>
                        <l-input-text
                            :label="$t(`reviews.updateParticipant.labelName`)"
                            :value="manager.fullname"
                            disabled
                        >
                            <template v-slot:addon>
                                <span class=" color-primary">
                                    <span
                                        v-show="manager.status == 'pending'"
                                        class="clickable"
                                        tabindex="0"
                                        @click="removeManagerAsOwner()"
                                        @keyup.enter="removeManagerAsOwner()"
                                    >
                                        <i class="fal fa-trash"></i>
                                    </span>
                                    <span
                                        v-show="manager.status == 'complete'"
                                        v-b-popover.hover.bottom="
                                            $t(`reviews.updateParticipant.unlockManagerAssessment`)
                                        "
                                        class="l-default-margin-s clickable"
                                        tabindex="0"
                                        @click="unlockManagerAsOwner()"
                                        @keyup.enter="unlockManagerAsOwner()"
                                    >
                                        <i v-show="manager.unlocked" class="fal fa-unlock"></i>
                                        <i v-show="!manager.unlocked" class="fal fa-lock"></i>
                                    </span>
                                    <span
                                        v-show="
                                            manager.status == 'complete' &&
                                                manager.visibility == 'private'
                                        "
                                        v-b-popover.hover.bottom="
                                            $t(`reviews.updateParticipant.shareManagerAssessment`)
                                        "
                                        class="l-default-margin-s clickable"
                                        tabindex="0"
                                        @click="$set(manager, 'shared', !manager.shared)"
                                        @keyup.enter="$set(manager, 'shared', !manager.shared)"
                                    >
                                        <i v-show="manager.shared" class="fal fa-share-all"></i>
                                        <i v-show="!manager.shared" class="fal fa-share"></i>
                                    </span>
                                </span>
                            </template>
                        </l-input-text>
                    </template>
                    <p v-show="manager.user" class="explanation" style="margin-top: -10px">
                        <span>{{ $t(`reviews.updateParticipant.labelTransferContributor`) }}</span>
                        <span
                            v-show="reviewCycle.managerReviewsEnabled"
                            class="tw-mr-2 tw-cursor-pointer"
                            tabindex="0"
                            @click="
                                transferContributorAsOwner('managers', index, 'additionalManagers')
                            "
                            @keyup.enter="
                                transferContributorAsOwner('managers', index, 'additionalManagers')
                            "
                            >{{ $t(`reviews.updateParticipant.labelMakeAdditionalManager`) }}</span
                        >
                        <span
                            v-show="reviewCycle.peerReviewsEnabled"
                            class="tw-mr-2 tw-cursor-pointer"
                            tabindex="0"
                            @click="transferContributorAsOwner('managers', index, 'peers')"
                            @keyup.enter="transferContributorAsOwner('managers', index, 'peers')"
                            >{{ $t(`reviews.updateParticipant.labelMakePeer`) }}</span
                        >
                        <span
                            v-show="reviewCycle.directReportReviewsEnabled"
                            class="tw-mr-2 tw-cursor-pointer"
                            tabindex="0"
                            @click="transferContributorAsOwner('managers', index, 'directReports')"
                            @keyup.enter="
                                transferContributorAsOwner('managers', index, 'directReports')
                            "
                            >{{ $t(`reviews.updateParticipant.labelMakeDirectReport`) }}</span
                        >
                    </p>
                </div>
                <p
                    v-if="error && error.source == 'updateManagerAsOwner' && error.message"
                    class="color-warning explanation"
                >
                    {{ error.message }}
                </p>
            </div>

            <!-- update additional managers -->
            <div
                v-if="
                    reviewCycle.managerReviewsEnabled &&
                        reviewCycle.createdAsRole != 'manager' &&
                        reviewCycle.createdAsRole != 'employee'
                "
            >
                <h4>
                    <l-text
                        :text="
                            $t(`reviews.updateParticipant.labelAdditionalManagerOf`, {
                                name: participant.reviewee.fullname,
                            })
                        "
                    />
                </h4>

                <l-space :size="1" />

                <div
                    v-for="(additionalManager, index) in participant.additionalManagers"
                    :key="additionalManager._id"
                >
                    <l-input-text
                        :label="$t(`reviews.updateParticipant.labelName`)"
                        :value="additionalManager.fullname"
                        disabled
                    >
                        <template v-slot:addon>
                            <span class="color-primary">
                                <span
                                    v-show="additionalManager.status == 'pending'"
                                    class="clickable"
                                    tabindex="0"
                                    @click="remove360ReviewerAsOwner(index, 'additionalManagers')"
                                    @keyup.enter="
                                        remove360ReviewerAsOwner(index, 'additionalManagers')
                                    "
                                >
                                    <i class="fal fa-trash"></i>
                                </span>
                                <span
                                    v-show="additionalManager.status == 'complete'"
                                    v-b-popover.hover.bottom="
                                        $t(`reviews.updateParticipant.unlockDirectReportAssessment`)
                                    "
                                    class="clickable l-default-margin-s"
                                    tabindex="0"
                                    @click="
                                        unlockDirectReportAsOwner(
                                            index,
                                            additionalManager.unlocked ? false : true,
                                        )
                                    "
                                    @keyup.enter="
                                        unlockDirectReportAsOwner(
                                            index,
                                            additionalManager.unlocked ? false : true,
                                        )
                                    "
                                >
                                    <i
                                        v-show="additionalManager.unlocked"
                                        class="fal fa-unlock"
                                    ></i>
                                    <i v-show="!additionalManager.unlocked" class="fal fa-lock"></i>
                                </span>
                            </span>
                        </template>
                    </l-input-text>
                    <p class="explanation" style="margin-top: -10px">
                        <span>
                            {{ $t(`reviews.updateParticipant.labelTransferContributor`) }}
                        </span>
                        <span
                            v-show="reviewCycle.managerReviewsEnabled"
                            class="tw-mr-2 tw-cursor-pointer"
                            tabindex="0"
                            @click="
                                transferContributorAsOwner('additionalManagers', index, 'managers')
                            "
                            @keyup.enter="
                                transferContributorAsOwner('additionalManagers', index, 'managers')
                            "
                        >
                            {{ $t(`reviews.updateParticipant.labelMakeManager`) }}
                        </span>
                        <span
                            v-show="reviewCycle.managerReviewsEnabled"
                            class="tw-mr-2 tw-cursor-pointer"
                            tabindex="0"
                            @click="
                                transferContributorAsOwner('additionalManagers', index, 'peers')
                            "
                            @keyup.enter="
                                transferContributorAsOwner('additionalManagers', index, 'peers')
                            "
                        >
                            {{ $t(`reviews.updateParticipant.labelMakePeer`) }}
                        </span>
                        <span
                            v-show="reviewCycle.directReportReviewsEnabled"
                            class="tw-mr-2 tw-cursor-pointer"
                            tabindex="0"
                            @click="
                                transferContributorAsOwner(
                                    'additionalManagers',
                                    index,
                                    'directReports',
                                )
                            "
                            @keyup.enter="
                                transferContributorAsOwner(
                                    'additionalManagers',
                                    index,
                                    'directReports',
                                )
                            "
                        >
                            {{ $t(`reviews.updateParticipant.labelMakeDirectReport`) }}
                        </span>
                    </p>

                    <l-space :size="1" />
                </div>

                <template
                    v-if="
                        !(
                            participant.managers &&
                            participant.managers[0] &&
                            participant.managers[0].user
                        )
                    "
                >
                    <l-input-text
                        :label="$t(`reviews.updateParticipant.labelAddAdditionalManager`)"
                        disabled
                    >
                        <template v-slot:addon>
                            <span class="color-primary">
                                <i class="fal fa-plus"></i>
                            </span>
                        </template>
                    </l-input-text>
                </template>
                <template v-else>
                    <div style="display: flex; align-content: center;">
                        <l-input-typeahead
                            style="flex-grow: 1;"
                            :label="$t(`reviews.updateParticipant.labelAddAdditionalManager`)"
                            :data="users"
                            :on-select="item => add360ReviewerAsOwner(item, 'additionalManager')"
                            :on-input-change="typeaheadUsersOnInput"
                        >
                        </l-input-typeahead>
                        <span
                            class="color-primary"
                            style="padding: 0px 12px;padding-top: 18px;font-size: 1.8rem;"
                        >
                            <i class="fal fa-plus"></i>
                        </span>
                    </div>
                </template>

                <l-space :size="1" />

                <l-select
                    :label="$t(`reviews.updateParticipant.labelAddAdditionalManagerReportTeam`)"
                    :value="selectedTeamAdditionalManager"
                    :options="optionsTeam"
                    @change="
                        e => {
                            selectedTeamAdditionalManager = e.target.value;
                            addTeamAsOwner(selectedTeamAdditionalManager, 'additionalManager');
                        }
                    "
                    ><template v-slot:addon>
                        <span class="color-primary"> <i class="fal fa-plus"></i> </span></template
                ></l-select>

                <p
                    v-if="error && error.source == 'addAdditionalManagerAsOwner' && error.message"
                    class="color-warning explanation"
                >
                    {{ error.message }}
                </p>
            </div>

            <!-- Updating direct reports -->

            <div v-if="reviewCycle.directReportReviewsEnabled">
                <h4>
                    <l-text
                        :text="
                            $t(`reviews.updateParticipant.labelDirectReportOf`, {
                                name: participant.reviewee.fullname,
                            })
                        "
                    />
                </h4>

                <l-space :size="1" />

                <div
                    v-for="(directReport, index) in participant.directReports"
                    :key="directReport._id"
                >
                    <l-input-text
                        v-model="directReport.fullname"
                        :label="$t(`reviews.updateParticipant.labelName`)"
                        disabled
                    >
                        <template v-slot:addon>
                            <span class=" color-primary">
                                <span
                                    v-show="directReport.status == 'pending'"
                                    class="clickable"
                                    tabindex="0"
                                    @click="remove360ReviewerAsOwner(index, 'directReports')"
                                    @keyup.enter="remove360ReviewerAsOwner(index, 'directReports')"
                                >
                                    <i class="fal fa-trash"></i>
                                </span>
                                <span
                                    v-show="directReport.status == 'complete'"
                                    v-b-popover.hover.bottom="
                                        $t(`reviews.updateParticipant.unlockDirectReportAssessment`)
                                    "
                                    tabindex="0"
                                    class="clickable l-default-margin-s"
                                    @click="
                                        unlockDirectReportAsOwner(
                                            index,
                                            participant.directReports[index].unlocked
                                                ? false
                                                : true,
                                        )
                                    "
                                    @keyup.enter="
                                        unlockDirectReportAsOwner(
                                            index,
                                            participant.directReports[index].unlocked
                                                ? false
                                                : true,
                                        )
                                    "
                                >
                                    <i
                                        v-show="participant.directReports[index].unlocked"
                                        class="fal fa-unlock"
                                    ></i>
                                    <i
                                        v-show="!participant.directReports[index].unlocked"
                                        class="fal fa-lock"
                                    ></i>
                                </span>
                            </span>
                        </template>
                    </l-input-text>

                    <p class="explanation" style="margin-top: -10px">
                        <span>{{ $t(`reviews.updateParticipant.labelTransferContributor`) }}</span>
                        <span
                            v-show="reviewCycle.managerReviewsEnabled"
                            class="tw-mr-2 tw-cursor-pointer"
                            tabindex="0"
                            @click="transferContributorAsOwner('directReports', index, 'managers')"
                            @keyup.enter="
                                transferContributorAsOwner('directReports', index, 'managers')
                            "
                            >{{ $t(`reviews.updateParticipant.labelMakeManager`) }}</span
                        >
                        <span
                            v-show="reviewCycle.managerReviewsEnabled"
                            class="tw-mr-2 tw-cursor-pointer"
                            tabindex="0"
                            @click="
                                transferContributorAsOwner(
                                    'directReports',
                                    index,
                                    'additionalManagers',
                                )
                            "
                            @keyup.enter="
                                transferContributorAsOwner(
                                    'directReports',
                                    index,
                                    'additionalManagers',
                                )
                            "
                            >{{ $t(`reviews.updateParticipant.labelMakeAdditionalManager`) }}</span
                        >
                        <span
                            v-show="reviewCycle.peerReviewsEnabled"
                            class="tw-mr-2 tw-cursor-pointer"
                            tabindex="0"
                            @click="transferContributorAsOwner('directReports', index, 'peers')"
                            @keyup.enter="
                                transferContributorAsOwner('directReports', index, 'peers')
                            "
                            >{{ $t(`reviews.updateParticipant.labelMakePeer`) }}</span
                        >
                    </p>

                    <l-space :size="1" />
                </div>
                <div style="display: flex; align-content: center;">
                    <l-input-typeahead
                        style="flex-grow: 1;"
                        :label="$t(`reviews.updateParticipant.labelAddDirectReport`)"
                        :placeholder="``"
                        :data="users"
                        :on-select="item => add360ReviewerAsOwner(item, 'directReport')"
                        :on-input-change="typeaheadUsersOnInput"
                    >
                    </l-input-typeahead>
                    <span
                        class="color-primary"
                        style="padding: 0px 12px;padding-top: 18px;font-size: 1.8rem;"
                    >
                        <i class="fal fa-plus"></i>
                    </span>
                </div>

                <l-space :size="1" />

                <l-select
                    :label="$t(`reviews.updateParticipant.labelAddDirectReportTeam`)"
                    :value="selectedDirectReportTeam"
                    :options="optionsTeam"
                    @change="
                        e => {
                            selectedDirectReportTeam = e.target.value;
                            addTeamAsOwner(selectedDirectReportTeam, 'directReport');
                        }
                    "
                >
                    <template v-slot:addon>
                        <span class=" color-primary"> <i class="fal fa-plus"></i> </span
                    ></template>
                </l-select>
                <p
                    v-if="error && error.source == 'addDirectReportAsOwner' && error.message"
                    class="color-warning explanation"
                >
                    {{ error.message }}
                </p>
            </div>

            <!-- Updating peers -->

            <div v-if="reviewCycle.peerReviewsEnabled">
                <h4>
                    <l-text
                        :text="
                            $t(`reviews.updateParticipant.labelPeerOf`, {
                                name: participant.reviewee.fullname,
                            })
                        "
                    />
                </h4>

                <l-space :size="1" />

                <div v-for="(peer, index) in participant.peers" :key="peer._id">
                    <l-input-text
                        v-model="peer.fullname"
                        :label="$t(`reviews.updateParticipant.labelName`)"
                        disabled
                    >
                        <template v-slot:addon>
                            <span class="color-primary">
                                <span
                                    v-show="peer.status == 'pending'"
                                    class="clickable"
                                    tabindex="0"
                                    @click="remove360ReviewerAsOwner(index, 'peers')"
                                    @keyup.enter="remove360ReviewerAsOwner(index, 'peers')"
                                >
                                    <i class="fal fa-trash"></i>
                                </span>
                                <span
                                    v-show="peer.status == 'complete' || peer.status == 'declined'"
                                    v-b-popover.hover.bottom="
                                        $t(`reviews.updateParticipant.unlockPeerAssessment`)
                                    "
                                    tabindex="0"
                                    class="clickable l-default-margin-s"
                                    @click="
                                        unlockPeerAsOwner(
                                            index,
                                            participant.peers[index].unlocked ? false : true,
                                        )
                                    "
                                    @keyup.enter="
                                        unlockPeerAsOwner(
                                            index,
                                            participant.peers[index].unlocked ? false : true,
                                        )
                                    "
                                >
                                    <i
                                        v-show="participant.peers[index].unlocked"
                                        class="fal fa-unlock"
                                    ></i>
                                    <i
                                        v-show="!participant.peers[index].unlocked"
                                        class="fal fa-lock"
                                    ></i>
                                </span>
                            </span>
                        </template>
                    </l-input-text>

                    <p class="explanation" style="margin-top: -10px">
                        <span>{{ $t(`reviews.updateParticipant.labelTransferContributor`) }}</span>
                        <span
                            v-show="reviewCycle.managerReviewsEnabled"
                            class="tw-mr-2 tw-cursor-pointer"
                            tabindex="0"
                            @click="transferContributorAsOwner('peers', index, 'managers')"
                            @keyup.enter="transferContributorAsOwner('peers', index, 'managers')"
                            >{{ $t(`reviews.updateParticipant.labelMakeManager`) }}</span
                        >
                        <span
                            v-show="reviewCycle.managerReviewsEnabled"
                            class="tw-mr-2 tw-cursor-pointer"
                            tabindex="0"
                            @click="
                                transferContributorAsOwner('peers', index, 'additionalManagers')
                            "
                            @keyup.enter="
                                transferContributorAsOwner('peers', index, 'additionalManagers')
                            "
                            >{{ $t(`reviews.updateParticipant.labelMakeAdditionalManager`) }}</span
                        >
                        <span
                            v-show="reviewCycle.directReportReviewsEnabled"
                            class="tw-mr-2 tw-cursor-pointer"
                            tabindex="0"
                            @click="transferContributorAsOwner('peers', index, 'directReports')"
                            @keyup.enter="
                                transferContributorAsOwner('peers', index, 'directReports')
                            "
                            >{{ $t(`reviews.updateParticipant.labelMakeDirectReport`) }}</span
                        >
                    </p>

                    <l-space :size="1" />
                </div>

                <div style="display: flex; align-content: center;">
                    <l-input-typeahead
                        style="flex-grow: 1;"
                        :label="$t(`reviews.updateParticipant.labelAddPeer`)"
                        :placeholder="``"
                        :data="users"
                        :on-select="item => add360ReviewerAsOwner(item, 'peer')"
                        :on-input-change="typeaheadUsersOnInput"
                    >
                    </l-input-typeahead>
                    <span
                        class="color-primary"
                        style="padding: 0px 12px;padding-top: 18px;font-size: 1.8rem;"
                    >
                        <i class="fal fa-plus"></i>
                    </span>
                </div>

                <l-space :size="1" />

                <l-select
                    :label="$t(`reviews.updateParticipant.labelAddPeerTeam`)"
                    :value="selectedTeamPeer"
                    :options="optionsTeam"
                    @change="
                        e => {
                            selectedTeamPeer = e.target.value;
                            addTeamAsOwner(selectedTeamPeer, 'peer');
                        }
                    "
                >
                    <template v-slot:addon>
                        <span class="color-primary">
                            <i class="fal fa-plus"></i>
                        </span>
                    </template>
                </l-select>

                <p
                    v-if="error && error.source == 'addPeerAsOwner' && error.message"
                    class="color-warning explanation"
                >
                    {{ error.message }}
                </p>
                <p class="explanation">
                    <span>{{ $t(`reviews.updateParticipant.helpStatusPeers`) }}</span>
                </p>
            </div>

            <!-- Other settings -->

            <p class="explanation">
                <span>{{ $t(`reviews.updateParticipant.helpNotifications`) }}</span>
            </p>

            <div v-if="participant._id">
                <div v-show="reviewCycle.createdAsRole != 'employee'">
                    <div class="hr-small"></div>

                    <p
                        class="text-center color-danger clickable"
                        tabindex="0"
                        @click="removeParticipantWarning = true"
                        @keyup.enter="removeParticipantWarning = true"
                    >
                        <i class="fal fa-trash"></i>
                        <span class="l-default-margin-s">{{
                            $t(`reviews.updateParticipant.helpRemoveParticipant`)
                        }}</span>
                    </p>
                    <div class="hr-small"></div>
                </div>
            </div>

            <p
                v-if="error && error.source == 'updateActiveParticipant' && error.message"
                class="color-warning explanation"
            >
                {{ error.message }}
            </p>
        </div>
        <div id="modal-footer" style="text-align: right; margin-top: 20px">
            <button class="btn btn-default" type="button" @click="cancel()">
                {{ $t(`reviews.updateParticipant.btnCancel`) }}
            </button>
            <button
                v-show="!isNew"
                style="margin: auto;"
                class="btn btn-primary btn-raised"
                type="button"
                @click="updateActiveParticipant()"
            >
                {{ $t(`reviews.updateParticipant.btnUpdate`) }}
            </button>
            <button
                v-show="isNew"
                style="margin: auto;"
                class="btn btn-primary btn-raised"
                type="button"
                @click="updateActiveParticipant()"
            >
                {{ $t(`reviews.updateParticipant.btnCreate`) }}
            </button>
        </div>
        <l-confirmation-modal
            v-if="removeParticipantWarning"
            :text="$t(`reviews.updateParticipant.helpRemoveParticipantConfirm`)"
            @confirm="updateActiveParticipant(true, false)"
            @cancel="removeParticipantWarning = false"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import api from "@/api";

import format from "@/utils/format-typeahead";

import LInputText from "@/components/LInputText";
import LInputTypeahead from "@/components/LInputTypeahead";
import LSelect from "@/components/LSelect";
import LSpace from "@/components/LSpace";
import LText from "@/components/LText";
import LConfirmationModal from "@/components/LConfirmationModal";

export default {
    components: {
        LInputText,
        LInputTypeahead,
        LSelect,
        LSpace,
        LText,
        LConfirmationModal,
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
        reviewCycle: {
            type: Object,
            required: true,
        },
        isNew: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            participant: {
                reviewee: {
                    user: "",
                    fullname: "",
                    status: "",
                },
                managers: [],
                additionalManagers: [],
                peers: [],
                directReports: [],
            },

            error: null,

            selectedTeamAdditionalManager: "",
            selectedDirectReportTeam: "",
            selectedTeamPeer: "",

            removeParticipantWarning: false,
        };
    },
    computed: {
        ...mapGetters({
            localTeams: "teams/local/listSortedByName",
            usersSearchList: "users/search/list",
            getUserList: "users/list/list",
        }),

        users() {
            return this.usersSearchList.map(user => ({ ...user, ...format.users(user) }));
        },
        optionsTeam() {
            return [
                { value: "", text: this.$t(`reviews.admin.optionFullTeam`) },
                { value: "company", text: this.$t(`reviews.admin.optionAllColleagues`) },
                ...this.localTeams.map(team => ({ value: team._id, text: team.name })),
            ];
        },
    },
    watch: {
        user: {
            immediate: true,
            handler(participant) {
                this.participant = { ...participant };
            },
        },
    },
    methods: {
        typeaheadUsersOnInput(query) {
            if (query.length >= 2) {
                this.$store.dispatch("users/search/findByName", { query, sort: "default" });
            } else {
                this.$store.dispatch("users/search/reset");
            }
        },

        unlockRevieweeAsOwner(unlocked) {
            this.$set(this.participant.reviewee, "unlocked", unlocked);
        },

        updateManagerAsOwner(manager) {
            this.$store.dispatch("users/search/reset");

            // reset error

            this.error = {};

            // check if new user is already set as peer or direct report

            let reviewerExists = false;

            this.participant.peers.forEach(function(peer) {
                if (peer.user == manager._id) reviewerExists = true;
            });

            this.participant.directReports.forEach(function(directReport) {
                if (directReport.user == manager._id) reviewerExists = true;
            });

            this.participant.additionalManagers.forEach(function(additionalManager) {
                if (additionalManager.user == manager._id) reviewerExists = true;
            });

            if (reviewerExists) {
                this.error = {
                    source: "updateManagerAsOwner",
                    message: this.$t("reviews.updateParticipant.errorManagerIsPeer"),
                };
                return;
            }

            // check if user is reviewee or manager

            if (manager._id == this.participant.reviewee._id) {
                this.error = {
                    source: "updateManagerAsOwner",
                    message: this.$t("reviews.updateParticipant.errorManagerIsReviewee"),
                };
                return;
            }

            // update manager (& block input)

            this.$set(this.participant, "managers", [
                {
                    user: manager._id,
                    fullname: manager.fullname,
                    status: "pending",
                    editInput: false,
                },
            ]);
        },
        removeManagerAsOwner() {
            this.participant.managers = [{ user: null, status: "pending", fullname: "" }];

            this.participant.managers[0].editInput = true;
        },
        unlockManagerAsOwner() {
            this.$set(
                this.participant.managers[0],
                "unlocked",
                this.participant.managers[0].unlocked ? false : true,
            );
        },

        transferContributorAsOwner(currentRole, currentIndex, newRole) {
            // abort manager changes in certain states

            if (
                (currentRole == "managers" || newRole == "managers") &&
                this.participant.stats &&
                ["signed"].includes(this.participant.stats.managerAggregateStatus)
            ) {
                return;
            }

            // extract and label current contributor

            var currentContributor = this.participant[currentRole][currentIndex];

            currentContributor.transferredFrom = currentRole;

            // delete old instance

            this.participant[currentRole].splice(currentIndex, 1);

            // special case: switch for manager, as there can only be one

            if (newRole == "managers" && this.participant.managers.length) {
                // track the change

                var oldManager = this.participant.managers[0];
                oldManager.transferredFrom = "managers";

                // switch

                this.participant[currentRole].push(oldManager);
                this.participant.managers.splice(0, 1);
            }

            if (currentRole == "managers") {
                this.participant.managers = [
                    { user: null, status: "pending", fullname: "", editInput: true },
                ];
            }

            // move contributor

            this.participant[newRole].push(currentContributor);
        },

        remove360ReviewerAsOwner(index, role) {
            this.participant[role].splice(index, 1);
        },
        unlockDirectReportAsOwner(index, unlocked) {
            if (this.participant.directReports[index]) {
                this.$set(this.participant.directReports[index], "unlocked", unlocked);
            }
        },

        add360ReviewerAsOwner(user, role, addingInBatch) {
            this.$store.dispatch("users/search/reset");

            // different data structure than addPeer, hence different function

            // reset error

            this.error = {};

            // set arrays if not present

            if (!this.participant.peers) this.participant.peers = [];

            if (!this.participant.directReports) this.participant.directReports = [];

            if (!this.participant.managers) this.participant.managers = [];

            if (!this.participant.additionalManagers) this.participant.additionalManagers = [];

            // check if new user is already set as peer or direct report

            var reviewerExists = false;

            var source = "";
            if (role == "peer") {
                source = "addPeerAsOwner";
            } else if (role == "directReport") {
                source = "addDirectReportAsOwner";
            } else if (role == "additionalManager") {
                source = "addAdditionalManagerAsOwner";
            }

            this.participant.managers.forEach(function(manager) {
                if (manager.user == user._id) reviewerExists = true;
            });

            this.participant.peers.forEach(function(peer) {
                if (peer.user == user._id) reviewerExists = true;
            });

            this.participant.directReports.forEach(function(directReport) {
                if (directReport.user == user._id) reviewerExists = true;
            });

            this.participant.additionalManagers.forEach(function(additionalManager) {
                if (additionalManager.user == user._id) reviewerExists = true;
            });

            if (reviewerExists) {
                if (!addingInBatch) {
                    this.error = {
                        source: source,
                        message: this.$t("reviews.updateParticipant.errorReviewerPresent"),
                    };
                }

                return;
            }

            // check if user is reviewee or manager

            if (user._id == this.participant.reviewee.user) {
                if (!addingInBatch) {
                    this.error = {
                        source: source,
                        message: this.$t("reviews.updateParticipant.errorPeerIsReviewee"),
                    };
                }

                return;
            }

            // add to peer array

            if (role == "peer") {
                this.participant.peers.push({
                    user: user._id,
                    fullname: user.fullname,
                    status: "pending",
                });
            } else if (role == "directReport") {
                this.participant.directReports.push({
                    user: user._id,
                    fullname: user.fullname,
                    status: "pending",
                });
            } else if (role == "additionalManager") {
                this.participant.additionalManagers.push({
                    user: user._id,
                    fullname: user.fullname,
                    status: "pending",
                });
            }
        },
        async addTeamAsOwner(selectedTeam, role) {
            if (!selectedTeam) return;

            // reset error

            this.error = {};

            // add team

            var filter;

            if (selectedTeam === "reports") {
                filter = { admin: [{ _id: "reportsSearch" }] };
            } else if (selectedTeam === "company") {
                filter = { status: ["active", "invited", "created"] };
            } else {
                filter = { localTeams: [{ _id: selectedTeam }] };
            }

            await this.$store.dispatch({
                type: "users/list/get",
                payload: { userFilter: { include: filter } },
            });

            const users = this.getUserList();
            users.forEach(user => this.add360ReviewerAsOwner(user, role, true));
        },

        unlockPeerAsOwner(index, unlocked) {
            this.$set(this.participant.peers[index], "unlocked", unlocked);
        },

        updateActiveParticipant(removeParticipant, removeSignatures) {
            api.post("/api/reviewcycles/update/participants/active", {
                reviewCycle: this.reviewCycle._id,
                participant: this.participant,
                removeParticipant,
                removeSignatures,
            }).then(response => {
                if (!response.data.success) {
                    this.error = response.data.error;
                } else {
                    this.cancel();
                }
            });
        },

        cancel() {
            this.$router.push(`/reviews/cycles/edit/${this.reviewCycle._id}/status`);
        },
    },
};
</script>
